export const moneyAmount = value => {
  if (value == null || value === '') return null;
  if (typeof value === 'object') {
    if (value.amount != null) return Number(value.amount);
    if (value.amount_cents != null) return Number(value.amount_cents) / 100;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const formatMoney = value => {
  const amount = moneyAmount(value);
  return amount == null
    ? '-'
    : new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: value?.currency || 'BRL',
      }).format(amount);
};

export const formatDate = value => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? String(value)
    : date.toLocaleDateString('pt-BR');
};

export const leaseStatusMeta = status =>
  ({
    active: {
      label: 'Ativa',
      className: 'bg-emerald-50 text-emerald-700',
    },
    draft: {
      label: 'Rascunho',
      className: 'bg-slate-100 text-slate-700',
    },
    terminated: {
      label: 'Rescindida',
      className: 'bg-rose-50 text-rose-700',
    },
    renewed: {
      label: 'Renovada',
      className: 'bg-sky-50 text-sky-700',
    },
  })[status] || {
    label: status || 'Indisponível',
    className: 'bg-slate-100 text-slate-700',
  };

export const invoiceStatusMeta = status =>
  ({
    open: {
      label: 'Em aberto',
      className: 'bg-amber-50 text-amber-700',
    },
    partially_paid: {
      label: 'Parcial',
      className: 'bg-sky-50 text-sky-700',
    },
    paid: {
      label: 'Paga',
      className: 'bg-emerald-50 text-emerald-700',
    },
    overdue: {
      label: 'Vencida',
      className: 'bg-rose-50 text-rose-700',
    },
    canceled: {
      label: 'Cancelada',
      className: 'bg-slate-100 text-slate-700',
    },
  })[status] || {
    label: status || 'Indisponível',
    className: 'bg-slate-100 text-slate-700',
  };

export const payoutStatusMeta = status =>
  ({
    pending: {
      label: 'Pendente',
      className: 'bg-amber-50 text-amber-700',
    },
    approved: {
      label: 'Aprovado',
      className: 'bg-sky-50 text-sky-700',
    },
    paid: {
      label: 'Pago',
      className: 'bg-emerald-50 text-emerald-700',
    },
    canceled: {
      label: 'Cancelado',
      className: 'bg-slate-100 text-slate-700',
    },
  })[status] || {
    label: status || 'Indisponível',
    className: 'bg-slate-100 text-slate-700',
  };

export const pendingSeverityMeta = severity =>
  ({
    critical: {
      className: 'border-rose-200 bg-rose-50 text-rose-800',
      icon: 'i-lucide-triangle-alert',
    },
    warning: {
      className: 'border-amber-200 bg-amber-50 text-amber-800',
      icon: 'i-lucide-clock-3',
    },
  })[severity] || {
    className: 'border-slate-200 bg-slate-50 text-slate-700',
    icon: 'i-lucide-circle-alert',
  };

export const defaultReadjustmentForm = operation => ({
  applied_index: operation?.readjustment?.criterion || 'IGPM',
  effective_competency:
    operation?.readjustment?.next_effective_competency || '',
  index_factor: '1.0000',
  count: operation?.readjustment?.periodicity_months || 12,
});

export const defaultPayoutCompetency = operation =>
  operation?.owner_payouts?.suggested_competency ||
  operation?.billing?.charges?.find(item => item.status === 'paid')
    ?.competency ||
  '';
